import React, { Component } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Link from '../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import PropertyFeature from './cards/property-feature'
import PropertyCard from './cards/property'
import ProjectSmallCard from './cards/project-small'

class LatestProperties extends Component {

  state = {
    type: false,
  }

  constructor(props) {
    super(props)
    this.slider = React.createRef()
  }

  componentDidMount() {
    this._toggleType(0)
    let isDown = false;
    let startX;
    let scrollLeft;
    this.initial = 0;

    this.slider.current.addEventListener('mousedown', (event) => {
      isDown = true;
      startX = event.pageX - this.slider.current.offsetLeft;
      scrollLeft = this.slider.current.scrollLeft;
      this.initial = 0;
    });
    this.slider.current.addEventListener('mouseleave', (event) => {
      isDown = false;
    });
    this.slider.current.addEventListener('mouseup', (event) => {
      isDown = false;
    });
    this.slider.current.addEventListener('mousemove', (event) => {
      if(!isDown) return;
      event.preventDefault();
      const x = event.pageX - this.slider.current.offsetLeft;
      const walk = (x - startX) * 2; //scroll-fast
      this.initial += Math.abs(walk);
      this.slider.current.scrollLeft = scrollLeft - walk;
    });
  }

  _toggleType = (item) => {
    if ( this.state.type[item] ) return
    this.setState({type: {[item]: !this.state.type[item]} })
  }

  sliderLink = (event) => {
    if (this.initial > 10) event.preventDefault();
  }

  render() {

    let { title } = this.props
    let { type } = this.state
    let { residential, commercial, projects } = this.props.data

    return (
      <section className='latest-properties'>
        { residential?.edges.length > 0 &&
          <PropertyFeature {...residential.edges[0].node} postType={`property`} />
        }
        <div className='property-options__content'> 
          <div className='property-options__menu'>
            <ul>
              <li className={type[0] && 'active'}>
                <button 
                  type='button'
                  onClick={() => this._toggleType(0)}
                >
                  Residential
                </button>
              </li>
              <li className={type[1] && 'active'}>
                <button 
                  type='button'
                  onClick={() => this._toggleType(1)}
                >
                  Commercial
                </button>
              </li>
              <li className={type[2] && 'active'}>
               <button 
                  type='button'
                  onClick={() => this._toggleType(2)}
                >
                  New Projects
                </button>
              </li>
            </ul>
          </div>
          <div className='property-options__slides'>
            <div className='property-options__slider' ref={this.slider}>
              {type[0] && residential?.edges?.map((el, i) => (
                <PropertyCard {...el.node} postType='property' key={i} onClick={this.sliderLink} />
              ))}
              {type[1] && commercial?.edges?.map((el, i) => (
                <PropertyCard {...el.node} postType='property' key={i} onClick={this.sliderLink} />
              ))}
              {type[2] && projects?.edges?.map((el, i) => (
                <ProjectSmallCard {...el.node} postType='project' key={i} onClick={this.sliderLink} />
              ))}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default function LatestPropertiesQuery(props) {
  return (
    <StaticQuery
      query={graphql`
      query LatestPropertiesQuery {
        residential: allWpProperty(
          sort: {propertyListing: {onMarketDate: DESC}}
          limit: 4
          filter: {propertyData: {type: {eq: "Residential"}}, propertyListing: {status: {eq: "Available"}, hiddenListing: {eq: false}, offMarketListing:
      {eq: false}}}
        ) {
          edges {
            node {
              databaseId
              id
              slug
              title
              propertyAddress {
                hideAddress
                streetAddress
                suburb
                state
                postcode
              }
              propertyData {
                bathrooms
                bedrooms
                type
                carPorts
                carSpaces
                garages
                totalParking
                category
              }
              propertyImages {
                url
                small
                large
              }
              propertyListing {
                searchPrice
                marketingStatus
                displayPrice
              }
            }
          }
        }
        commercial: allWpProperty(
          sort: {propertyListing: {onMarketDate: DESC}}
          limit: 4
          filter: {propertyData: {type: {eq: "Commercial"}}, propertyListing: {status: {eq: "Available"}, hiddenListing: {eq: false}, offMarketListing:
      {eq: false}}}
        ) {
          edges {
            node {
              databaseId
              id
              slug
              title
              propertyAddress {
                hideAddress
                streetAddress
                suburb
                state
                postcode
              }
              propertyData {
                bathrooms
                bedrooms
                type
                carPorts
                carSpaces
                garages
                totalParking
                category
              }
              propertyImages {
                url
                small
                large
              }
              propertyListing {
                searchPrice
                marketingStatus
                displayPrice
              }
            }
          }
        }
        projects: allWpProject(
          filter: {acf: {hideOnMainSite: {ne: true}}}
          sort: {date: DESC}, 
          limit: 4
        ) {
          edges {
            node {
              title
              slug
              databaseId
              mainImage {
                url
              }
              details {
                category
                displayPrice
                mainDescription
                mainHeadline
                name
                stage
                status
                officeId
              }
              address {
                streetAddress
                suburb
                state
                postcode
                hideAddress
              }
            }
          }
        }
      }
      `}
      render={data => (
        <LatestProperties data={data} {...props} />
      )}
    />
  )
}
